export enum VoucherSeriesTypes {
  G = 'G - Shopware', // shopware
  D = 'D - Geschäft', // store
  P = 'P - Shopware'
}
